import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useClientAuth } from '../../contexts/ClientAuthContext';
import { useClientTheme } from '../../contexts/ClientThemeContext';

export default function ClientLoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, loading } = useClientAuth();
  const { theme: T } = useClientTheme();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const inputStyle = {
    width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8,
    border: `1px solid ${T.inputBorder}`, background: T.inputBg,
    color: T.inputColor, fontSize: 13, outline: 'none',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password) { setError('Username and password are required.'); return; }
    try {
      setSubmitting(true);
      await login(username.trim(), password);
      const redirectTo = location.state?.from?.pathname || '/client-portal/dashboard';
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || 'Authentication failed.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return null;

  return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'inherit' }}>
      <div style={{ width: '100%', maxWidth: 400, padding: 32, borderRadius: 16, border: `1px solid ${T.border}`, background: T.surface, boxShadow: T.id === 'light' ? '0 4px 24px rgba(55,65,81,0.12)' : '0 4px 24px rgba(0,0,0,0.5)' }}>
        <div style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', color: T.gold, marginBottom: 8 }}>
            Studio Sivad
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, color: T.text, marginBottom: 6 }}>Client Portal</div>
          <div style={{ fontSize: 13, color: T.textMuted, lineHeight: 1.5 }}>
            Sign in to review approvals, campaign plans, and share design direction.
          </div>
        </div>

        {error && (
          <div style={{ padding: '9px 12px', borderRadius: 8, border: `1px solid ${T.errorBorder}`, background: T.errorBg, color: T.errorText, fontSize: 12, marginBottom: 16 }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: T.label, display: 'block', marginBottom: 6 }}>Username</label>
            <input type="text" autoFocus value={username} onChange={(e) => setUsername(e.target.value)} placeholder="your username" style={inputStyle} autoCapitalize="none" autoCorrect="off" />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: T.label, display: 'block', marginBottom: 6 }}>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" style={inputStyle} />
          </div>
          <button
            type="submit"
            disabled={submitting || loading}
            style={{ marginTop: 4, padding: '11px 0', borderRadius: 8, border: `1px solid ${T.gold}`, background: T.gold, color: '#0e0e0e', fontWeight: 700, fontSize: 13, cursor: submitting ? 'not-allowed' : 'pointer', opacity: submitting ? 0.7 : 1, letterSpacing: '0.04em' }}
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
